export default __webpack_public_path__ + "static/media/kr.5110064d.svg";